/* eslint-disable no-param-reassign */
import produce from 'immer';
import { GET_PRODUCT_CATEGORY_TYPES } from 'src/actions/productCategoryTypeActions';

const initialState = {
  types: []
};

const productCategoryTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_CATEGORY_TYPES: {
      const { types } = action.payload;

      return produce(state, (draft) => {
        draft.types = types;
      });
    }

    default: {
      return state;
    }
  }
};

export default productCategoryTypeReducer;
